const publicRoutes = [
  '/login',
  '/signup',
  '/resetpassword',
  '/setpassword',
  '/',
  '/impressum',
  '/forgotpassword',
  '/accountactivated',
  '/activationfailed',
  '/benutzerregistrierung',
  '/externallogin',
];

export default publicRoutes;



// WEBPACK FOOTER //
// ./src/app/util/publicRoutes.js